/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Request DTO pro aktualizaci osvobození parcely budovy - obsahuje data o osvobození a zastavěné ploše
 */
export interface BuildingHeaderParRequestDto { 
    /**
     * ID budovy (bud_id) - sdílené napříč všemi verzemi budovy
     */
    budId: number;
    /**
     * ID prvního právního důvodu nároku na osvobození z číselníku DNE - Právní důvody osvobození
     */
    dnepduos1Id?: number | null;
    /**
     * Poslední rok osvobození dle prvního právního důvodu - rok, do něhož osvobození trvá (včetně)
     */
    dnepduos1Year?: number | null;
    /**
     * ID druhého právního důvodu nároku na osvobození z číselníku DNE - Právní důvody osvobození
     */
    dnepduos2Id?: number | null;
    /**
     * Poslední rok osvobození dle druhého právního důvodu - rok, do něhož osvobození trvá (včetně)
     */
    dnepduos2Year?: number | null;
    /**
     * ID třetího právního důvodu nároku na osvobození z číselníku DNE - Právní důvody osvobození
     */
    dnepduos3Id?: number | null;
    /**
     * Poslední rok osvobození dle třetího právního důvodu - rok, do něhož osvobození trvá (včetně)
     */
    dnepduos3Year?: number | null;
    /**
     * ID parcely z katastru nemovitostí (par_id) - sdílené napříč všemi verzemi parcely
     */
    parId: number;
    /**
     * ID parcely (primární klíč entity Parcel) - použito pro aktualizaci zastavěné výměry parcely
     */
    parcelId: number;
    /**
     * Zastavěná výměra parcely v m² - bude aktualizována v entitě Parcel
     */
    zastavenaVymera: number;
}

